<template>
  <div class="container" style="width:99%;margin-top:-25px;">
    <!--工具栏-->
    <div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
      <el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
        <el-form-item style="margin-bottom:0;" class="filter-item">
          <el-select v-model="filters.type" :placeholder="$t('RfProcessResource.type')" style="width: 150px;" @change="onTypeChange">
            <el-option :label="$t('RfProcessResource.option.any')" value="%"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.title')" value="title"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.header')" value="header"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.prompt')" value="prompt"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.option')" value="option"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:0;" class="filter-item">
          <el-select v-model="filters.name" :placeholder="$t('RfProcessResource.name')" size="small" style="width: 150px;">
            <el-option :label="$t('RfProcessResource.option.any')" value="%"></el-option>
            <el-option v-for="(name, index) in nameOptions" :key="index" :value="name" :label="name"/>
          </el-select>
        </el-form-item>
      </el-form>
      </div>
      <div class="action-bar">
        <kt-button :label="$t('action.search')" perms="sys:rfMainProcessDetail:view" type="primary" icon="el-icon-search" @click="findPage(null)"/>
        <kt-button :label="$t('action.add')" perms="sys:rfMainProcessDetail:add" type="primary" icon="el-icon-plus" @click="handleAdd"/>
      </div>
    </div>
    <!--表格内容栏-->
    <el-table :data="pageResult.content" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
          @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')" :border="border" :stripe="stripe"
          :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :height="height" :size="size" :align="align" style="width:100%;">
      <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="$t(column.label)" :width="column.width" :min-width="column.minWidth">
        <template slot-scope="scope">
          <span>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action.operation')" width="70" header-align="center" fixed="right" align="left">
        <template slot-scope="scope">
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-edit" :label="$t('action.edit')" perms="sys:rfMainProcessDetail:edit" size="mini" @click="handleEdit(scope.row)" />
          </div>
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-trash" :label="$t('action.delete')" perms="sys:rfMainProcessDetail:delete" size="mini" type="danger" @click="handleDelete(scope.row)" />
          </div>
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-copy" :label="$t('action.copy')" perms="sys:rfMainProcessDetail:add" size="mini" @click="handleCopy(scope.row)" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--新增编辑界面-->
    <el-dialog :title="operation ? $t('common.add') : $t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
      <el-form :model="dataForm" label-width="110px" :rules="dataFormRules" ref="dataForm" :size="size">
        <el-form-item :label="$t('RfProcessResource.name')" prop="name">
          <el-input v-model="dataForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfProcessResource.type')" prop="type">
          <el-select v-model="dataForm.type" style="width: 100%;">
            <el-option :label="$t('RfProcessResource.typeOption.title')" value="title"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.header')" value="header"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.prompt')" value="prompt"></el-option>
            <el-option :label="$t('RfProcessResource.typeOption.option')" value="option"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfProcessResource.localeId')" prop="localeId">
          <el-select v-model="dataForm.localeId" style="width: 100%;">
            <el-option :label="$t('RfProcessResource.localeIdOption.zh_cn')" value="2052"></el-option>
            <el-option :label="$t('RfProcessResource.localeIdOption.en_us')" value="1033"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfProcessResource.text')" prop="text">
          <el-input v-model="dataForm.text" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
export default {
name: 'RfProcessResourceDetail',
components: {
  KtTable,
  KtButton
},
data() {
  return {
    size: 'small',
    filters: {
      name: '',
      type: ''
    },
    nameOptions: [],
    columns: [
      {prop:"id", label:"RfProcessResource.id", minWidth:100},
      {prop:"name", label:"RfProcessResource.name", minWidth:100},
      {prop:"type", label:"RfProcessResource.type", minWidth:100},
      {prop:"text", label:"RfProcessResource.text", minWidth:100},
      {prop:"localeId", label:"RfProcessResource.localeId", minWidth:100},
      {prop:"createTime", label:"RfProcessResource.createTime", minWidth:100},
      {prop:"updateTime", label:"RfProcessResource.updateTime", minWidth:100}
    ],
    pageRequest: { pageNum: 1, pageSize: 8 },
    pageResult: {},
    operation: false, // true:新增, false:编辑
    editDialogVisible: false, // 新增编辑界面是否显示
    editLoading: false,
    highlightCurrentRow: false,
    loading: false,
    border: false,
    stripe: true,
    showOverflowTooltip: true,
    maxHeight: 520,
    height: 520,
    align: 'center',
    dataFormRules: {
      name: [
        { required: true, message: this.$t('RfProcessResource.dataFormRules.name'), trigger: 'blur' }
      ],
      type: [
        { required: true, message: this.$t('RfProcessResource.dataFormRules.type'), trigger: 'blur' }
      ],
      localeId: [
        { required: true, message: this.$t('RfProcessResource.dataFormRules.localeId'), trigger: 'blur' }
      ]
    },
    // 新增编辑界面数据
    dataForm: {
      id: null,
      name: null,
      type: null,
      localeId: null,
      text: null
    }
  }
},
methods: {
  onTypeChange() {
    // 当 type 改变时调用 getProcessResources 方法
    const type = this.filters.type; // 获取当前选择的 type
    this.$wmsApi.rfProcessResource.getProcessResources({ type }).then(res => {
      // 假设返回的数据是一个数组，更新 nameOptions
      this.nameOptions = res.data; // 根据实际返回的数据结构进行调整
    }).catch(error => {
      console.error("Error fetching process resources:", error);
    });
  },
  findPage: function (data) {
    console.log("findPage called with data:", data);
    if (data !== null && data.pageRequest) {
      this.pageRequest.pageNum = data.pageRequest.pageNum
      this.pageRequest.pageSize = data.pageRequest.pageSize;
    }
    let name = this.filters.name;
    let type = this.filters.type; 
    this.pageRequest.columnFilters = {
      name: { name: 'name', value: name },
      type: { name: 'type', value: type }
    };
    this.$wmsApi.rfProcessResource.findPage(this.pageRequest).then((res) => {
      console.log("API response:", res);
      this.pageResult = res.data;
    }).catch(error => {
      console.error("Error fetching data:", error);
    });
  },
  handleEdit(row) {
    this.editDialogVisible = true;
    this.operation = false;
    this.dataForm = Object.assign({}, row);
  },
  handleCopy(row) {
    this.editDialogVisible = true;
    this.operation = true;
    this.dataForm = {
      id: null,
      name: row.name,
      type: row.type,
      localeId: row.localeId,
      text: row.text
    };
  },
  handleAdd() {
    this.editDialogVisible = true; // 显示对话框
    this.operation = true; // 设置为新增操作
    this.dataForm = { // 清空表单数据
      id: null,
      name: null,
      type: null,
      localeId: null,
      text: null
    };
  },
  handleDelete(row) {
    this.$confirm(this.$t("common.message.confirmDelete"), this.$t("common.message.prompt"), {
      confirmButtonText: this.$t("common.message.confirm"),
      cancelButtonText: this.$t("common.message.cancel"),
      type: 'warning'
    }).then(() => {
      this.$wmsApi.rfProcessResource.batchDelete([row]).then(res => {
        if (res.code === 200) {
          this.$message({ message: this.$t("common.message.success"), type: 'success' });
          this.findPage(null);
        }
else {
          this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
        }
      });
    });
  },
  submitForm() {
    this.$refs.dataForm.validate((valid) => {
      if (valid) {
        this.$confirm(this.$t("common.message.confirmSubmission"), this.$t("common.message.prompt"), {
          confirmButtonText: this.$t("common.message.confirm"),
          cancelButtonText: this.$t("common.message.cancel"),
          type: 'warning'
        }).then(() => {
          this.$wmsApi.rfProcessResource.save(this.dataForm).then(res => {
            if (res.code === 200) {
              this.$message({ message: this.$t("common.message.success"), type: 'success' });
              this.editDialogVisible = false;
              // 刷新搜索栏名称下拉框
              this.onTypeChange();
              this.findPage(null);
            }
else {
              this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
            }
          });
        });
      }
    });
  }
},
//每次刷新页面都会触发
activated() {
    // 获取路由参数
    const { name, type } = this.$route.query;
    // 设置 filters
    if (name!==undefined) {
      this.filters.name = name || ''; // 默认值为空字符串
    }
if (type!==undefined) {
      this.filters.type = type || ''; // 默认值为空字符串
    }
if (this.filters.name && this.filters.type) {
        this.findPage(null);
    }
  }
}
</script>
<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}
/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}
/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}
/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}
/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}
/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}
/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
/* 固定列左侧隔断阴影线 */
/deep/ .el-table__fixed-right {
  border-left: 1px solid #e4e7ed !important;
}
/deep/ .el-table__fixed-right::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/Wms/RfProcessResourceDetail.vue